module.exports = __webpack_public_path__ + "img/1F1F3-1F1F5.3b7d7c56.svg";